import React, { useContext } from 'react';
import {
  locationAmenities,
  locationProducts,
  cardLockFilters,
  retailFilters,
} from '../../utils/map';
import { useTranslation } from 'react-i18next';
import { FilterContext } from './locationFinder';

export default function LocationFilters() {
  const { t } = useTranslation();

  const {
    activeFilterIds,
    handleFilterChange,
    activeTypeId,
    activeFilterProductIds,
    handleProductFilterChange,
  } = useContext(FilterContext);

  return (
    <fieldset>
      <legend className="tw-mb-4 tw-text-lg tw-font-bold tw-text-center tw-uppercase tw-text-nfnGreen-dark">
        {t('FILTER BY AMENITIES')}
      </legend>
      <div className="tw-grid tw-grid-cols-2 tw-gap-2 ">
        {locationAmenities
          .filter((filter) => {
            if (activeTypeId === 'cardLock') {
              return cardLockFilters.find((f) => f === filter.value);
            }
            if (activeTypeId === 'retail') {
              return retailFilters.find((f) => f === filter.value);
            }
            if (activeTypeId === 'all-locations') {
              return true;
            }
            return false;
          })
          .map((filter) => (
            <div
              key={filter.id}
              className="tw-relative tw-flex tw-items-center tw-border-b tw-gap-1 ">
              <input
                id={`filter-${filter.id}`}
                name={`filter-${filter.id}`}
                type="checkbox"
                checked={activeFilterIds.includes(filter.id)}
                onChange={() => {
                  handleFilterChange(filter.id);
                }}
                className="tw-w-4 tw-h-4 tw-border-gray-300 tw-rounded focus:tw-ring-yellow tw-text-yellow tw-accent-blue"
              />
              <div className="tw-min-w-0 tw-text-sm">
                <label
                  htmlFor={`filter-${filter.id}`}
                  className="tw-font-medium tw-select-none">
                  {t(filter.value)}
                </label>
              </div>
            </div>
          ))}
        {locationProducts.map((filter) => (
          <div
            key={filter.ref}
            className="gap-1 tw-relative tw-flex tw-items-center tw-border-b">
            <input
              id={`filter-${filter.ref}`}
              name={`filter-${filter.ref}`}
              type="checkbox"
              checked={activeFilterProductIds.includes(filter.ref)}
              onChange={() => {
                handleProductFilterChange(filter.ref);
              }}
              className="tw-w-4 tw-h-4 tw-border-gray-300 tw-rounded tw-accent-blue"
            />
            <div className="tw-min-w-0 tw-text-sm">
              <label
                htmlFor={`filter-${filter.ref}`}
                className="tw-font-medium tw-select-none">
                {t(filter.enValue)}
              </label>
            </div>
          </div>
        ))}
      </div>
    </fieldset>
  );
}
